import { createAction } from "redux-act";
import { AclInfo, PublicAccessUpdate } from "./types";

export const updateAcl = createAction<PublicAccessUpdate>("acl/update");
export const setAcl = createAction<AclInfo>("acl/set");
export const setLoading = createAction<boolean>("acl/set-loading");
export const setError = createAction<Error>("acl/set-error");
export const reset = createAction("acl/reset");
